import { useEffect, useState } from "react";
import { appInsights } from "../../config/appInsights";
import ToggleTab from "./../../NewComponents/ToggleTab/ToggleTab.component";
import InvestmentProductRequest from "./Tabs/InvestmentProductRequest";
import InvestorRequests from "./Tabs/InvestorRequests";
import LoggedOfflineInvestment from "./Tabs/LoggedOfflineInvestment";

export default function ApprovalRequest() {
  const [activeTab, setActiveTab] = useState("activation-requests");

  useEffect(() => {
    appInsights.trackPageView({
      name: "Admin Investment Approvals - (ApprovalRequest.jsx)",
      isLoggedIn: true,
    });
  }, []);

  return (
    <div className="datatable-wrapper">
      <div className="table-view speed-1x animated fadeInRight">
        <h3 className="page-title mb-4">Approval Requests (Investments)</h3>
        <div className="alignToggleTabItems mb-3">
          <ToggleTab
            text="Fund Activation Requests"
            id="activation-requests"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <ToggleTab
            text="Investor Creation Requests"
            id="investor-requests"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <ToggleTab
            text="Logged Offline Requests"
            id="logged-offline"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
        <div>
          {(() => {
            switch (activeTab) {
              case "activation-requests":
                return <InvestmentProductRequest />;
              case "investor-requests":
                return <InvestorRequests />;
              case "logged-offline":
                return <LoggedOfflineInvestment />;
              default:
                return null;
            }
          })()}
        </div>
      </div>
    </div>
  );
}
